import React, { useState ,useEffect} from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../Components/Sidebar/Sidebar";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import DashboardNav from "../../Components/DashboardHeader/DashboardNav";
import { addUser, getErrorByField } from "../../Api/auth";
import { Form } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { useLocation } from 'react-router-dom';
import {  getCurrentUser } from "../../Api/auth";

function AddCustomer() {

    // const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const ftParam = queryParams.get('ft');
    // console.log("parameterName", ftParam);
    const [show03, setShow03] = useState(false);

    const handleClose03 = () => setShow03(false);
    const handleShow03 = () => setShow03(true);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [show, setShow] = useState(false);

    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);
    const [apicall, setApicall] = useState(false);

    const [heightft, setHeightft] = useState('');
    const [heightin, setHeightin] = useState('');
    const [dexterity, setDexterity] = useState('');

    const [staff_role, setStaff_role] = useState(0);
 

    const initData = {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        // height_ft: "",
        // height_in: "",
        wrist_to_floor: "",
        shoulder_to_wrist: "",
        elbow_to_wrist: "",
        address: "",
        city: "",
        state: "",
        zip: "",
    };
    const [formData, setFormData] = useState(initData);

    const dataChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    const handleSubmit = async (e) => {
        setApicall(true);
        e.preventDefault();
        formData.role_id = 4;
        formData.password = "123456";
        formData.height_ft = heightft;
        formData.height_in = heightin;
        formData.dexterity = dexterity;
        formData.staff_role = staff_role;
        const data = formData;
        addUser(data, e).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                handleShow03();
            }
            else { 
                setApicall(false);
                handleShow();
                setFormData(initData);
                setValidated(false);
                setHeightft('');
                setHeightin('');
                setDexterity('');
                // if (ftParam === "iron") {
                if(staff_role === 1){
                    window.location.href = "fitter-customer"
                }else{
                    window.location.href = "customer-details/" + res.data.data._id;
                }
                // } else {
                // window.location.href = "/dashboard";
                // }
                return;
            }
        }).catch((err) => {
            alert(err);
        }
        ).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    };

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);
        if (getCurrentUserdata && getCurrentUserdata.user) {
            setStaff_role(getCurrentUserdata.user.role_id);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);


    return (

        <div>
            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="logo-modal mb-4 text-center">
                        <img src={require('../../assets/images/logo_text.png')} alt="logo" />
                    </div>
                    <h3 className="text-center">
                        Customer Add successfully
                    </h3>
                </Modal.Body>
            </Modal>
            <Modal
                show={show03}
                onHide={handleClose03}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <h2 className="text-center mb-3">
                        You missed something!
                    </h2>
                    <p className="text-center mb-4">
                        Please fill out every input field in this section.
                    </p>

                    <button type="button" className="btn btn-modal-view" onClick={handleClose03}>
                        OK, got it!
                    </button>
                </Modal.Body>
            </Modal>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>New Customer</h3>
                                        </div>
                                        <div className="dashboard-sec">
                                            <div className="container-fulid">
                                                <div className="form-box-section mt-4">
                                                    <div className="form-box-inner">
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">Name</label>
                                                                <input type="text"
                                                                    required
                                                                    className={`form-control dashboard-input-box-1 me-1  ${errors.length > 0 ? getErrorByField(errors, "firstname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                    placeholder="First"
                                                                    value={formData.firstname}
                                                                    name={"firstname"}
                                                                    onChange={(e) => dataChange(e)}
                                                                />
                                                                <input type="text"
                                                                    required
                                                                    className={`form-control dashboard-input-box-1 ${errors.length > 0 ? getErrorByField(errors, "lastname").length > 0 ? "is-invalid" : "" : ""}`}
                                                                    placeholder="Last"
                                                                    name={"lastname"}
                                                                    value={formData.lastname}
                                                                    onChange={(e) => dataChange(e)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <Form.Label className="dashboard-form-lable">Email</Form.Label>
                                                                <Form.Control
                                                                    type="email"
                                                                    className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'email').length > 0 ? 'is-invalid' : ''}`}
                                                                    placeholder="Email Address"
                                                                    name="email"
                                                                    required
                                                                    value={formData.email}
                                                                    onChange={(e) => dataChange(e)} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "email").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter valid email"
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">Phone</label>
                                                                <input
                                                                    type="number"
                                                                    name={"phone"}
                                                                    required
                                                                    className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'phone_number').length > 0 ? 'is-invalid' : ''}`}
                                                                    placeholder="Phone Number"
                                                                    value={formData.phone}
                                                                    onChange={(e) => dataChange(e)} />
                                                                <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "phone_number").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter valid phone number"
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </div>

                                                        </div>



                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">Address</label>
                                                                <input
                                                                    type="text"
                                                                    name={"address"}
                                                                    // required
                                                                    className={`form-control dashboard-input-box-2`}
                                                                    placeholder="Street address"
                                                                    value={formData.address}
                                                                    onChange={(e) => dataChange(e)} />
                                                                {/* <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "address").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter address"
                                                                    }
                                                                </Form.Control.Feedback> */}
                                                            </div>

                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">City</label>
                                                                <input
                                                                    type="text"
                                                                    name={"city"}
                                                                    // required
                                                                    // className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'city').length > 0 ? 'is-invalid' : ''}`}
                                                                    className={`form-control dashboard-input-box-2`}
                                                                    placeholder="City"
                                                                    value={formData.city}
                                                                    onChange={(e) => dataChange(e)} />
                                                                {/* <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "city").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter city"
                                                                    }
                                                                </Form.Control.Feedback> */}
                                                            </div>

                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">State</label>
                                                                <input
                                                                    type="text"
                                                                    name={"state"}
                                                                    // required
                                                                    // className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'state').length > 0 ? 'is-invalid' : ''}`}
                                                                    className={`form-control dashboard-input-box-2`}
                                                                    placeholder="State"
                                                                    value={formData.state}
                                                                    onChange={(e) => dataChange(e)} />
                                                                {/* <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "state").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter State"
                                                                    }
                                                                </Form.Control.Feedback> */}
                                                            </div>

                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">Zip</label>
                                                                <input
                                                                    type="text"
                                                                    name={"zip"}
                                                                    // required
                                                                    // className={`form-control dashboard-input-box-2 ${getErrorByField(errors, 'zip').length > 0 ? 'is-invalid' : ''}`}
                                                                    className={`form-control dashboard-input-box-2`}
                                                                    placeholder="zip"
                                                                    value={formData.zip}
                                                                    onChange={(e) => dataChange(e)} />
                                                                {/* <Form.Control.Feedback type="invalid">
                                                                    {
                                                                        errors.length > 0 ? getErrorByField(errors, "zip").map((item) => {
                                                                            return item.detail;
                                                                        }) : "Please enter zip"
                                                                    }
                                                                </Form.Control.Feedback> */}
                                                            </div>

                                                        </div>
                                                        {/* <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">Wrist to Floor</label>
                                                                <input type="number" className="form-control dashboard-input-box w-18" name={"wrist_to_floor"} placeholder="in." value={formData.wrist_to_floor} onChange={(e) => dataChange(e)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">Shoulder to Wrist</label>
                                                                <input type="number" className="form-control dashboard-input-box w-18" name={"shoulder_to_wrist"} placeholder="in." value={formData.shoulder_to_wrist} onChange={(e) => dataChange(e)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-item">
                                                            <div className="form-group custom-form-group">
                                                                <label className="dashboard-form-lable">Elbow to Wrist</label>
                                                                <input type="number" className="form-control dashboard-input-box w-18" name={"elbow_to_wrist"} placeholder="in." value={formData.elbow_to_wrist} onChange={(e) => dataChange(e)} />
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className="box-title mt-4" style={{ color: '#ffffff' }}>
                                                    <h3>Your Height</h3>
                                                </div>
                                                <div className="form-box-section mt-4">
                                                    <div className="form-box-inner">
                                                        <div className="form-item height-form-iteam">
                                                            <div className="custom-form-group">
                                                                <label className="dashboard-form-lable">Height</label>
                                                                <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                                    {/* <input type="number" className="form-control dashboard-input-box w-30" name={"height_ft"} placeholder="ft." value={formData.height_ft} onChange={(e) => dataChange(e)} /> */}
                                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx  w-25" value={heightft} onChange={(e) => setHeightft(e.target.value)} aria-label="Default select example">
                                                                        <option value={0}>ft.</option>
                                                                        <option value="4">4 ft.</option>
                                                                        <option value="5">5 ft.</option>
                                                                        <option value="6">6 ft.</option>
                                                                        <option value="7">7 ft.</option>
                                                                    </select>
                                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" value={heightin} onChange={(e) => setHeightin(e.target.value)} aria-label="Default select example">
                                                                        <option value={0}>in.</option>
                                                                        <option value="1">0 in.</option>
                                                                        <option value="2">1 in.</option>
                                                                        <option value="3">2 in.</option>
                                                                        <option value="4">3 in.</option>
                                                                        <option value="5">4 in.</option>
                                                                        <option value="6">5 in.</option>
                                                                        <option value="7">6 in.</option>
                                                                        <option value="8">7 in.</option>
                                                                        <option value="9">8 in.</option>
                                                                        <option value="10">9 in.</option>
                                                                        <option value="11">10 in.</option>
                                                                        <option value="12">11 in.</option>
                                                                    </select>
                                                                    {/* <input type="number" className="form-control dashboard-input-box w-30" name={"height_in"} placeholder="in." value={formData.height_in} onChange={(e) => dataChange(e)} /> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="box-title mt-4" style={{ color: '#ffffff' }}>
                                                    <h3>Your Dexterity</h3>
                                                </div>
                                                <div className="form-box-section mt-4">
                                                    <div className="form-box-inner">
                                                        <div className="form-item height-form-iteam">
                                                            <div className="custom-form-group">
                                                                <label className="dashboard-form-lable">Dexterity</label>
                                                                <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" value={dexterity} onChange={(e) => setDexterity(e.target.value)} aria-label="Default select example">
                                                                        <option value={0}>Dexterity</option>
                                                                        <option value="1">Right Handed</option>
                                                                        <option value="2">Left Handed</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="sec-btn-group add_customer_btn mt-4">
                                                    <Link to="/list-customer">
                                                        <button className="btn btn-cancel">Exit without saving</button>
                                                    </Link>
                                                    {apicall ? (
                                                        <button className="btn btn-save disabled" disabled>
                                                            <Spinner animation="border" className="border-black" />
                                                        </button>
                                                    ) : (
                                                        <button className="btn btn-save" type="submit">Save new customer</button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}
export default AddCustomer;